export default [
  {
    path: '/primeiro-acesso',
    name: 'primeiroAcesso',
    component: () => import(/* webpackChunkName: "PrimeiroAcesso" */ '../../views/login/PrimeiroAcesso')
  },
  {
    path: '/login/pendencias',
    name: 'pendenciasDeLogin',
    component: () => import(/* webpackChunkName: "PendenciasDeLogin" */ '../../views/login/PendenciasDeLogin')
  },
  { // provisório, depois deverá ser removida
    path: '/lite/login',
    name: 'loginLite',
    component: () => import(/* webpackChunkName: "loginLite" */ '../../views/login/LoginLite')
  },
  {
    path: '/login/lite/token',
    name: 'loginLiteToken',
    component: () => import(/* webpackChunkName: "loginLiteToken" */ '../../views/login/LoginLiteToken')
  },
  {
    path: '/login/manager/token',
    name: 'loginManagerToken',
    component: () => import(/* webpackChunkName: "loginManagerToken" */ '../../views/login/LoginManagerToken')
  },
  {
    path: '/login/conta',
    name: 'loginGestaoConta',
    component: () => import(/* webpackChunkName: "loginConta" */ '../../views/login/LoginGestaoConta')
  },
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/Login')
  },
  {
    path: '/redefinir-senha-office/:tenant/:token',
    name: 'redefinir-senha-office',
    component: () => import(/* webpackChunkName: "redefinir-senha-office" */ '../../views/login/RedefinicaoSenhaOffice')
  },
  {
    path: '/alteracao-senha-office',
    name: 'alteracao-senha-office',
    component: () => import(/* webpackChunkName: "alteracao-senha-office" */ '../../views/login/AlteracaoSenhaOffice')
  },
  {
    path: '/:escritorio',
    name: 'loginEscritorio',
    component: () => import(/* webpackChunkName: "loginEscritorio" */ '../../views/login/Login')
  },
  {
    path: '/recuperar-senha',
    name: 'recuperar-senha',
    component: () => import(/* webpackChunkName: "recuperar-senha" */ '../../views/login/RecuperacaoSenha')
  },
  {
    path: '/recuperar-senha-office',
    name: 'recuperar-senha-office',
    component: () => import(/* webpackChunkName: "recuperar-senha-office" */ '../../views/login/RecuperacaoSenhaOffice')
  },
  {
    path: '/validacao-2fa-office',
    name: 'validacao-2fa-office',
    component: () => import(/* webpackChunkName: "validacao-2fa-office" */ '../../views/login/Validacao2fa')
  },
  {
    path: '/login/sso/retorno',
    name: 'ssoRetorno',
    component: () => import(/* webpackChunkName: "ssoRetorno" */ '../../views/login/SsoRetorno')
  }
]
